import { LuxDropdownMenu, LuxButton } from '@lux/wardrobe-lib'
import { createRef, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dropdown } from 'primereact/dropdown'
import { RadioButton } from 'primereact/radiobutton'
import './ActiveFilters.scss'
import { ID_ORIGINAL_FILTER_FE } from '@/app/models/filters'
import { deleteFilters, setFilterAsFavorite } from '@/app/redux/actions/filters'

const ActiveFilters = ({
    filters,
    filterSelected,
    setFilterSelected,
    clearLocaleEditedFilter,
    ...props
}) => {
    const intl = useIntl()

    const componentClass = 'smart-modals-active-filters'
    const [dropdownIcon, setDropdownIcon] = useState<'up' | 'down'>('down')
    const [refMap, setRefMap] = useState({})
    const [options, setOptions] = useState([])

    const originalFilterBE = filters?.find((filter) => filter.isOriginalFilter)

    useEffect(() => {
        setOptions([
            originalFilterBE
                ? {
                      value: originalFilterBE._id,
                      label: intl.formatMessage({
                          id: 'modals.active_saved_filters.original_filter',
                          defaultMessage: 'Original filter',
                      }),
                  }
                : {
                      value: ID_ORIGINAL_FILTER_FE,
                      label: intl.formatMessage({
                          id: 'modals.active_saved_filters.original_filter',
                          defaultMessage: 'Original filter',
                      }),
                  },
            ...filters
                .filter((filter) => !filter.isOriginalFilter)
                .map((filter) => ({ value: filter._id, label: filter.name })),
        ])
        const newRefMap = {}
        options.forEach((o) => (newRefMap[o.value] = createRef()))
        setRefMap(newRefMap)
    }, [filters])

    // const options = [
    //     originalFilterBE
    //         ? {
    //               value: originalFilterBE._id,
    //               label: intl.formatMessage({
    //                   id: 'modals.active_saved_filters.original_filter',
    //                   defaultMessage: 'Original filter',
    //               }),
    //           }
    //         : {
    //               value: ID_ORIGINAL_FILTER_FE,
    //               label: intl.formatMessage({
    //                   id: 'modals.active_saved_filters.original_filter',
    //                   defaultMessage: 'Original filter',
    //               }),
    //           },
    //     ...filters
    //         .filter((filter) => !filter.isOriginalFilter)
    //         .map((filter) => ({ value: filter._id, label: filter.name })),
    // ]
    // const newRefMap = {}
    // options.forEach((o) => (newRefMap[o.value] = createRef()))
    // setRefMap(newRefMap)

    const idOfDefaultFilter = filters.find((filter) => filter.isDefault)?._id ?? ''

    const panelsRefs = []

    const itemTemplate = (option) => {
        const itemPanelRef = useRef(option.value)
        panelsRefs.push(itemPanelRef)

        if (options?.length === 1 && option.value === ID_ORIGINAL_FILTER_FE) {
            return (
                <div className="no-filters-message">
                    {intl.formatMessage({
                        id: 'modals.active_saved_filters.no_custom_filters',
                        defaultMessage:
                            'No custom filters saved. Saved custom filters will appear here.',
                    })}
                </div>
            )
        }
        const isOriginalFilterFE = option.value === ID_ORIGINAL_FILTER_FE
        const isOriginalFilterBE = option.value === originalFilterBE?._id
        const checked = filterSelected === option.value
        const isDefault = option.value === idOfDefaultFilter

        const actions = []
        if (!(isDefault || isOriginalFilterFE || isOriginalFilterBE))
            actions.push({
                template: (
                    <LuxButton
                        iconLeft="star"
                        text={intl.formatMessage({
                            id: 'modals.filters.label.set_as_default',
                            defaultMessage: 'Set as default',
                        })}
                        classes="mb-2"
                        variant="text"
                        onClick={(e) => {
                            props.setFilterAsFavorite(option.value)
                        }}
                    />
                ),
            })
        if (!(isOriginalFilterFE || isOriginalFilterBE))
            actions.push({
                template: (
                    <LuxButton
                        iconLeft="trash"
                        text={intl.formatMessage({
                            id: 'modals.filters.label.delete',
                            defaultMessage: 'Delete',
                        })}
                        variant="text"
                        onClick={(e) => {
                            if (isOriginalFilterFE) {
                                clearLocaleEditedFilter()
                            } else {
                                props.deleteFilters(option.value)
                            }
                        }}
                    />
                ),
            })

        return (
            <div className={`${componentClass}-dropdown-item${checked ? ' checked' : ''}`}>
                <div>
                    <RadioButton
                        checked={checked}
                        name={option.label}
                        value={option.label}
                        onChange={() => setFilterSelected(option.value)}
                    />
                    {option.label}
                    {checked ? <i className="cu cu-check"></i> : <></>}
                </div>
                <div className="flex align-items-center">
                    {isDefault && <i className="cu cu-star"></i>}
                    {actions.length > 0 && (
                        <div
                            onClick={(event) => {
                                event.stopPropagation()
                                panelsRefs.forEach((p) => {
                                    if (p != itemPanelRef) {
                                        p.current.hide()
                                    }
                                })
                            }}>
                            <LuxDropdownMenu
                                icon="actions"
                                variant="icon text"
                                panelClasses="smart-modals-active-filters-dropdown-menu"
                                items={actions}
                                panelRef={refMap[option.value]}
                                onOpen={() => {
                                    Object.keys(refMap).forEach((op) => {
                                        if (op !== option.value && !!refMap[op].current) {
                                            refMap[op].current.hide()
                                        }
                                    })
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const valueTemplate = (option, props) => {
        if (option) {
            return <div>{option.label}</div>
        }
        return <span>{props.placeholder}</span>
    }

    return (
        <div className={componentClass}>
            <h1 className={`${componentClass}__title`}>
                {intl.formatMessage({
                    id: 'modals.filters.sidebar.title.active_saved_filters',
                    defaultMessage: 'Active and Saved Filters',
                })}
            </h1>
            <div className={`${componentClass}__dropdown`}>
                <Dropdown
                    value={filterSelected}
                    options={options}
                    optionLabel={'name'}
                    itemTemplate={itemTemplate}
                    valueTemplate={valueTemplate}
                    placeholder={intl.formatMessage({
                        id: 'modals.active_saved_filters.original_filter',
                        defaultMessage: 'Original filter',
                    })}
                    onChange={(e) => setFilterSelected(e.value)}
                    onShow={() => setDropdownIcon('up')}
                    onHide={() => setDropdownIcon('down')}
                    dropdownIcon={`cu cu-caret-${dropdownIcon}`}
                    panelClassName={`smart-modals-active-filters-dropdown-panel`}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({
    deleteFilters: (filterId: string) => {
        dispatch(deleteFilters(filterId))
    },

    setFilterAsFavorite: (filterId: string) => {
        dispatch(setFilterAsFavorite(filterId))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(ActiveFilters)
